import {
  reactQueryPatch,
  reactQueryPost,
} from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";

import type { FlaggedContentStatus } from "@/react/types/FlaggedContent";

export interface ApiResource {
  id?: string;
  params?: object;
}

export interface ModerationActionOptions {
  disableConnections?: boolean;
  disableDirectMessaging?: boolean;
  flagForChat?: boolean;
  flagForConnect?: boolean;
  flagMember?: boolean;
}

export const useModerationApi = () => {
  const exportCsv = (status: FlaggedContentStatus) =>
    reactQueryPost(internalApi.flaggedContent.exportCsv(status));

  const approve = (id: string, options: ModerationActionOptions = {}) =>
    reactQueryPatch(internalApi.flaggedContent.approve({ id }), {
      flag_member: options.flagMember,
      flag_for_connect: options.flagForConnect,
    });

  const reject = (
    id: string,
    reason: string | null,
    options: ModerationActionOptions = {},
  ) =>
    reactQueryPatch(internalApi.flaggedContent.reject({ id }), {
      action_reason_body: reason,
      flag_member: options.flagMember,
      flag_for_connect: options.flagForConnect,
      flag_for_chat: options.flagForChat,
      disable_direct_messaging: options.disableDirectMessaging,
      disable_connections: options.disableConnections,
    });

  return {
    exportCsv,
    approve,
    reject,
  };
};
